import * as Sentry from '@sentry/react';

export function initSentry(): void {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_UI_DSN,
    tunnel: '/auth/api/v0/sentry', // Proxy Sentry events through backend
    environment: window.PORTAL_ENV ?? import.meta.env.VITE_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate:
      Number(window.PORTAL_SENTRY_TRACES_SAMPLE_RATE) ||
      Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
    tracePropagationTargets: (
      window.PORTAL_SENTRY_TRACE_PROPAGATION_TARGETS ??
      import.meta.env.VITE_SENTRY_TRACE_PROPAGATION_TARGETS
    ) as string[] | RegExp[],
    normalizeDepth: 10,
    maxBreadcrumbs: 50,
    beforeSend(event) {
      // Filter out spam/bot events
      const msg = event.message ?? event.exception?.values?.[0]?.type ?? '';
      if (msg && /healthcheck|bot-test|test-error/i.test(msg)) return null;
      return event;
    },
  });
}
